import React from 'react'
import { Grid, Typography } from '@mui/material'
import useStyles from './Style'
import PhotoGallery from './photoGallery/PhotoGallery'
import clsx from 'clsx'
import { AboutTeamContent } from 'src/types/components/shared/atom'
interface Iprops {
  content: AboutTeamContent
  zenMode: boolean
}
const AboutTeam: React.FC<Iprops> = ({ content, zenMode }) => {
  const { classes } = useStyles()

  return (
    <Grid className={classes.rootContainer}>
      <Typography
        className={clsx(classes.text, zenMode && classes.zenModeText)}
      >
        {content.text}
      </Typography>
      <PhotoGallery zenMode={zenMode} content={content.cardData} />
    </Grid>
  )
}

export default AboutTeam
